import * as React from 'react';
import { SVGProps } from 'react';

const SvgStrengthening = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M11.9079 26.8946H9.67114V12.625H11.9079V26.8946ZM7.7443 25.4669H5.81665V14.1116H7.7443V25.4669ZM3.82287 24.0158H2V15.3494H3.82287V24.0158ZM30.3279 27.0662H28.0924V12.7966H30.3279V27.0662ZM34.183 25.5796H32.2554V14.2242H34.183V25.5796ZM37.9945 15.6755 37.999 24.3419H36.1713V15.6755H37.9945Z"
    />
    <path
      fill={props.fill}
      d="M29.4297 20.6348H12.0203V18.0742H27.0721L29.4297 20.6348Z"
    />
  </svg>
);

export default SvgStrengthening;
